"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showDefaultAlert = exports.urlPost = exports.handleNotification = exports.validateFile = exports.changeWidthHeightToPercentage = exports.convertImageUrlToFile = exports.isCloseToBottom = exports.stringToDateFormat = exports.secondToDateFormat = exports.formatNumber = exports.timeSince = exports.timeToDecimal = exports.actualOtTime = exports.getDayOfWeek = exports.formatPhoneNumber = exports.handleApiError = exports.handleApiError1 = exports.removeUndefinedAndNull = exports.isEmpty = exports.omitValueObject = exports.typeOf = exports.isAxiosUnprocessableEntityError = exports.hashtagRegex = exports.isWeb = exports.isAndroid = void 0;
const axios_1 = __importDefault(require("axios"));
const moment_1 = __importDefault(require("moment"));
const react_native_1 = require("react-native");
const enums_1 = require("../constants/enums");
const scale_1 = require("./scale");
exports.isAndroid = react_native_1.Platform.OS === 'android';
exports.isWeb = react_native_1.Platform.OS === 'web';
// export const hashtagRegex = /(^|[\s　\]|[＃#])([＃#][^#[\s　\]＃\n]+(?![^#[\s　\]＃\n]*[#＃]))/g
exports.hashtagRegex = /(^|[\s　\]|[＃#])([＃#][\wｰーぁ-ゖァ-ヺー一-龯]+(?![\wｰーぁ-ゖァ-ヺー一-龯]*[^\wｰーぁ-ゖァ-ヺー一-龯\s　\n]))/g;
const isAxiosUnprocessableEntityError = (error) => axios_1.default.isAxiosError(error) && error.response?.status === enums_1.HttpCode.UNPROCESSABLE_ENTITY;
exports.isAxiosUnprocessableEntityError = isAxiosUnprocessableEntityError;
// Check type variable
const typeOf = (obj) => Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
exports.typeOf = typeOf;
//obmit value obj
function omitValueObject(obj, key) {
    const { [key]: omitted, ...rest } = obj;
    return rest;
}
exports.omitValueObject = omitValueObject;
// Check Empty
function isEmpty(obj) {
    if (!obj || typeof obj !== 'object')
        return !obj;
    if (Array.isArray(obj)) {
        return !obj.length;
    }
    return !Object.keys(obj).length;
}
exports.isEmpty = isEmpty;
function removeUndefinedAndNull(obj) {
    const result = {};
    for (const key in obj) {
        if (obj[key] !== undefined && obj[key] !== null) {
            result[key] = obj[key];
        }
    }
    return result;
}
exports.removeUndefinedAndNull = removeUndefinedAndNull;
// handle Error Api
const handleApiError1 = (errorData) => {
    let _error = {};
    try {
        if (typeof errorData === 'object' && errorData !== null && 'error' in errorData) {
            const fieldErrors = errorData.error.message;
            Object.keys(fieldErrors).forEach((fieldName) => {
                const validationOption = fieldErrors[fieldName];
                if (validationOption) {
                    const firstValidationMessage = validationOption[0];
                    _error[fieldName] = firstValidationMessage;
                }
            });
            // add error to form value
            const errorResultArr = Object.keys(_error).map((fieldName) => ({
                name: fieldName,
                errors: [_error[fieldName]],
            }));
            return errorResultArr;
        }
    }
    catch (error) {
        console.log('Original error message:', error);
    }
};
exports.handleApiError1 = handleApiError1;
// handle Error from server
const handleApiError = (errorData) => {
    let _error = {};
    try {
        if (typeof errorData === 'object' && errorData !== null && 'error' in errorData) {
            const fieldErrors = errorData.error.message;
            Object.keys(fieldErrors).forEach((fieldName) => {
                const validationMessages = fieldErrors[fieldName];
                if (validationMessages && validationMessages.length > 0) {
                    const firstValidationMessage = validationMessages[0];
                    _error[fieldName] = firstValidationMessage;
                }
            });
        }
    }
    catch (error) {
        console.log('Original error message:', error);
    }
    return _error;
};
exports.handleApiError = handleApiError;
const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
        return '';
    }
    const start = phoneNumber.slice(0, 3);
    const content = phoneNumber.slice(3, 7);
    const end = phoneNumber.slice(7);
    return start + '-' + content + '-' + end;
};
exports.formatPhoneNumber = formatPhoneNumber;
const getDayOfWeek = (date) => {
    const day = (0, moment_1.default)(date).day();
    switch (day) {
        case 0:
            return 'Chủ nhật';
        case 1:
            return 'Thứ hai';
        case 2:
            return 'Thứ ba';
        case 3:
            return 'Thứ tư';
        case 4:
            return 'Thứ năm';
        case 5:
            return 'Thứ sáu';
        case 6:
            return 'Thứ bảy';
        default:
            break;
    }
};
exports.getDayOfWeek = getDayOfWeek;
const actualOtTime = async (duration, date) => {
    const dayOfWeek = (0, moment_1.default)(date).day();
    const isWeekend = dayOfWeek == 0 || dayOfWeek == 6;
    const hours = timeToDecimal(duration) || '0';
    const holidays = await getHoliday();
    const isDayOff = holidays.filter((i) => i?.start?.date == (0, moment_1.default)(date).format('YYYY-MM-YY')).length > 0;
    let actualWork = 0;
    let actualSabbatical = 0;
    if (isDayOff) {
        actualWork = (parseInt(hours) / 8) * 2;
        actualSabbatical = (parseInt(hours) / 8) * 1;
    }
    else if (isWeekend) {
        actualWork = (parseInt(hours) / 8) * 1.5;
        actualSabbatical = (parseInt(hours) / 8) * 0.5;
    }
    else {
        actualWork = (parseInt(hours) / 8) * 1;
        actualSabbatical = (parseInt(hours) / 8) * 0.5;
    }
    return {
        actualWork,
        actualSabbatical,
    };
};
exports.actualOtTime = actualOtTime;
const getHoliday = async () => {
    const BASE_CALENDAR_URL = 'https://www.googleapis.com/calendar/v3/calendars';
    const BASE_CALENDAR_ID_FOR_PUBLIC_HOLIDAY = 'holiday@group.v.calendar.google.com'; // Calendar Id. This is public but apparently not documented anywhere officialy.
    const API_KEY = 'AIzaSyCp5RCSLZrwEDvabrKVS_1bgqCN8uy3858';
    const CALENDAR_REGION = 'en.vietnamese';
    const url = `${BASE_CALENDAR_URL}/${CALENDAR_REGION}%23${BASE_CALENDAR_ID_FOR_PUBLIC_HOLIDAY}/events?key=${API_KEY}`;
    const res = await axios_1.default.get(url);
    const holidays = res?.data?.items;
    const dayOff = holidays.filter((value) => {
        if ((value?.summary == 'Tet holiday' ||
            value?.summary == "International New Year's Day" ||
            value?.summary == 'International Labor Day' ||
            value?.summary == 'Vietnamese New Year' ||
            value?.summary == 'Independence Day Holiday' ||
            value?.summary == 'Hung Kings Festival' ||
            value?.summary == 'Liberation Day/Reunification Day') &&
            value?.start?.date.includes(`${(0, moment_1.default)().year()}`)) {
            return value?.start?.date;
        }
    });
    return dayOff;
};
function timeToDecimal(duration) {
    if (!duration) {
        return 0;
    }
    const t = duration.split(':');
    const hour = parseInt(t[0], 10);
    const des = parseInt(t[1], 10) / 60;
    return parseFloat((hour + des).toString()).toFixed(3);
}
exports.timeToDecimal = timeToDecimal;
function timeSince(time) {
    const date = (0, moment_1.default)(time).valueOf();
    //@ts-ignore
    var seconds = Math.floor((new Date() - date) / 1000);
    var interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + ' năm trước';
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + ' tháng trước';
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + ' ngày trước';
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + ' giờ trước';
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + ' phút trước';
    }
    return Math.floor(seconds) + ' giây trước';
}
exports.timeSince = timeSince;
function numberWithCommas(x) {
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x))
        x = x.replace(pattern, '$1,$2');
    return x;
}
const formatNumber = (number) => {
    if (number < 10000) {
        return numberWithCommas(number.toString());
    }
    const val = Math.floor((number / 10000) * 100) / 100;
    return numberWithCommas(val.toString()) + '万';
};
exports.formatNumber = formatNumber;
const secondToDateFormat = (number) => {
    if (!number)
        return '';
    const targetTime = (0, moment_1.default)(number);
    const duration = moment_1.default.duration((0, moment_1.default)().diff(targetTime));
    const absoluteDuration = Math.abs(duration.asMilliseconds());
    if (absoluteDuration < 60000) {
        return '1分以内';
    }
    else if (absoluteDuration < 3600000) {
        return Math.floor(absoluteDuration / 60000) + '分前';
    }
    else if (absoluteDuration < 86400000) {
        return Math.floor(absoluteDuration / 3600000) + '時間前';
    }
    return moment_1.default.unix(number / 1000).format('YYYY/MM/DD');
};
exports.secondToDateFormat = secondToDateFormat;
const stringToDateFormat = (time) => {
    if (!time)
        return '';
    const currentTime = (0, moment_1.default)();
    const createTime = (0, moment_1.default)(time);
    const duration = moment_1.default.duration(currentTime.diff(createTime));
    const minutesDiff = +duration.asMinutes().toFixed(0);
    const hDiff = +duration.asHours().toFixed(0);
    const sameDay = currentTime.isSame(createTime, 'day');
    if (!sameDay) {
        return (0, moment_1.default)(time).format('YYYY/MM/DD');
    }
    else if (minutesDiff < 1 || minutesDiff == 1) {
        return '1分以内';
    }
    else if (minutesDiff < 60 && minutesDiff > 1) {
        return `${minutesDiff}分前`;
    }
    else if (hDiff < 24 && hDiff >= 1) {
        return `${hDiff}時間前`;
    }
    return (0, moment_1.default)(time).format('YYYY/MM/DD');
};
exports.stringToDateFormat = stringToDateFormat;
const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize, }) => {
    const paddingToBottom = (0, scale_1.scale)(20);
    return layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom;
};
exports.isCloseToBottom = isCloseToBottom;
const fetchImageAsBlob = (url) => {
    return new Promise((resolve, reject) => {
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => resolve(blob))
            .catch((error) => reject(error));
    });
};
const createFileFromBlob = (blob, fileName) => {
    return new File([blob], fileName, {
        type: blob.type,
        lastModified: (0, moment_1.default)().unix(),
    });
};
const convertImageUrlToFile = async (url) => {
    try {
        const blob = await fetchImageAsBlob(url);
        const imageType = blob.type.split('/').pop() || 'jpeg';
        let fileName = `${(0, moment_1.default)().unix().toString()}.${imageType}`;
        const file = createFileFromBlob(blob, fileName);
        return file;
    }
    catch (error) {
        return;
    }
};
exports.convertImageUrlToFile = convertImageUrlToFile;
// Hàm thay đổi width và height thành tỷ lệ phần trăm
const changeWidthHeightToPercentage = (html) => {
    // Biểu thức chính quy để tìm các cặp width và height
    var regex = /width="(\d+)"|height="(\d+(\.\d+)?)"/g;
    // Thay thế width và height bằng tỷ lệ phần trăm
    // @ts-ignore
    var result = html.replace(regex, function (match, _width, _height) {
        if (_width) {
            var percentageWidth = Math.min((parseInt(_width) / (scale_1.width - 32)) * 100, 100); // Tính tỷ lệ phần trăm width
            return 'width="' + percentageWidth + '%"';
        }
        else if (_height) {
            var percentageHeight = Math.min((parseFloat(_height) / scale_1.height) * 100, 100); // Tính tỷ lệ phần trăm height
            return 'height="' + percentageHeight + '%"';
        }
    });
    return result;
};
exports.changeWidthHeightToPercentage = changeWidthHeightToPercentage;
const validateFile = (file, maxMb, type) => {
    const validImageTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
    const validVideoTypes = ['video/quicktime', 'video/mp4'];
    if (type == 'image' && !validImageTypes.includes(file.type)) {
        exports.isWeb
            ? alert('jpg, jpeg, png, webpタイプのファイルを指定してください。')
            : react_native_1.Alert.alert('jpg, jpeg, png, webpタイプのファイルを指定してください。');
        return false;
    }
    if (type == 'video' && !validVideoTypes.includes(file.type)) {
        exports.isWeb
            ? alert('mp4, movタイプのファイルを指定してください。')
            : react_native_1.Alert.alert('mp4, movタイプのファイルを指定してください。');
        return false;
    }
    if (file.size > maxMb * 1024 * 1024) {
        exports.isWeb
            ? alert(`アップロードできるファイルのサイズは${maxMb}MBまでです。`)
            : react_native_1.Alert.alert(`アップロードできるファイルのサイズは${maxMb}MBまでです。`);
        return false;
    }
    return true;
};
exports.validateFile = validateFile;
const handleNotification = (url) => {
    let directUrl = '';
    const regex = /api\/v1\/([^/]+)(?:\/([^/]+))*/;
    const matches = url.match(regex);
    if (matches) {
        const params = matches[0].split('/').slice(2); // Bắt đầu từ index 2 để bỏ qua "api/v1/"
        switch (params[0]) {
            case 'users':
                directUrl = `/users/${params[2]}`;
                break;
            case 'tweets':
                // const postId = params[params.length - 1]
                params.splice(0, 1);
                const firestorePath = params.join('/');
                directUrl = `/post?postId=${firestorePath ? firestorePath : ''}`;
                break;
            case 'comments':
                if (!!params[3]) {
                    directUrl = `/article/detail-comment?articleId=${params[1]}${!!params[3] ? '&postId=' + params[3] : ''}`;
                }
                else {
                    directUrl = `/article/list_comment_article?articleId=${params[1]}`;
                }
                break;
            case 'articles':
                directUrl = `/detail-story/${params[1]}`;
                break;
            default:
                break;
        }
    }
    return directUrl;
};
exports.handleNotification = handleNotification;
const urlPost = (data) => {
    const path = data?.split('/');
    const result = path?.slice(1).join('/');
    return result;
};
exports.urlPost = urlPost;
const showDefaultAlert = ({ title, content }) => {
    exports.isWeb ? alert(content) : react_native_1.Alert.alert(title, content);
};
exports.showDefaultAlert = showDefaultAlert;
